import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

/*
  Types of preloader components that can be displayed
*/
export enum PreloaderType {
  None,
  ProgressBarDeterminate,
  ProgressBarIndeterminate
}

@Injectable()
export class UiService {
  public showPreloader = true;
  /*
  preloader components configuration. Property's values must mimic the corresponding values of the materialize-css library.
  - showProgressBar: true/false
  - showSpinner: true/false
  - progressBar:
  * type:
  - determinate: display a fixed progress bar
  - indeterminate: display a moving progress bar
  * width: percentage of the bar that will be displayed filled
  * spinner:
  - color: color and shape of the icon to show
  */
  preloaderConfig = {
    showProgressBar: false,
    progressBar: {
      type: 'indeterminate'
      // width: this.domSanitizer.bypassSecurityTrustStyle('0%')
    }
  };

  constructor(private router: Router, public domSanitizer: DomSanitizer) {}

  setShowPreloader(flag: boolean) {
    this.showPreloader = flag;
  }

  // Displays a preloader component
  displayPreloader(type: PreloaderType, options?: any) {
    if (!this.showPreloader) {
      return;
    }
    switch (type) {
      case PreloaderType.ProgressBarDeterminate:
        this.preloaderConfig.showProgressBar = true;
        this.preloaderConfig.progressBar.type = 'determinate';
        if (options && options.width) {
          // this.preloaderConfig.progressBar.width = this.domSanitizer.bypassSecurityTrustStyle(options.width + '%');
        }
        break;

      case PreloaderType.ProgressBarIndeterminate:
        this.preloaderConfig.showProgressBar = true;
        this.preloaderConfig.progressBar.type = 'indeterminate';
        break;
    }
  }

  // Hide the preloader component
  hidePreloader(type?: PreloaderType) {
    switch (type) {
      case PreloaderType.ProgressBarDeterminate:
      case PreloaderType.ProgressBarIndeterminate:
        this.preloaderConfig.showProgressBar = false;
        break;
      default:
        this.preloaderConfig.showProgressBar = false;
        break;
    }
  }
}
